/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Templates_OtherInputs */



/**
* | output |
* | --- |
* | "Other meetings" |
*
* @param {Settings_Templates_OtherInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_templates_other = /** @type {((inputs?: Settings_Templates_OtherInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Templates_OtherInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Overige gesprekken")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Autres réunions")
	return /** @type {LocalizedString} */ ("Other meetings")
});